import { TmsJob } from 'data/records'
import { fulfilled } from 'lib/promiseMiddlewareHelpers'
import { resource, member, findSelector, withAllResults } from 'data/helpers/apiv3'
import { Map } from 'immutable'

const [api, actions] = resource(TmsJob, [
  ['createOrders', member.post('orders')]
])
actions.allJobs = withAllResults(actions.list)

const selectors = {
  ...findSelector(TmsJob),
  orders: (state, id) => state.apiv3.tmsJob.orders.get(id)
}

const initialState = {
  orders: Map() // jobId -> orders dict
}

const reducers = {
  [fulfilled(actions.read.type)]: (state, action) => {
    const { tmsJob, meta: { orders } } = action.payload
    return state.setIn(['orders', tmsJob.id], orders || {})
  }
}

export {
  api as tmsJobApi,
  actions as tmsJobActions,
  selectors as tmsJobSelectors,
  reducers as tmsJobReducers,
  initialState as tmsJobInitialState
}
